import React from "react";
import { HelpCircle } from "design_system/Icon";
import { NavBar as DSNav } from "widgets/NavBar";
import { Text } from "design_system/Text";
import { Color } from "../../utils/enums";
import { NAV_MENU_V3_ENGAGEMENTS } from "./constants";
import { recordPatientAppClickEngagement } from "../../utils/engagements";

interface HelpCenterCtaV3Props {
    className?: string;
    helpCenterUrl?: string;
}
export const HelpCenterCtaV3 = ({ className = "ml-auto", helpCenterUrl }: HelpCenterCtaV3Props) => {
    return (
        <DSNav.TopBar.Link
            leadingIcon={<HelpCircle color={Color.WHITE} aria-hidden="true" />}
            className={className}
            href={helpCenterUrl}
            onClick={() => recordPatientAppClickEngagement(NAV_MENU_V3_ENGAGEMENTS.GET_HELP_BTN)}
        >
            <Text>{gettext("Get help")}</Text>
        </DSNav.TopBar.Link>
    );
};
